import type { Media } from "@dealer-center/inventory-pages-gvm-interface";

export function isIoF(media: Media) {
  return media.url.includes("imageonthefly");
}

export function isVideo(media: Media) {
  return media.fileType === "swf" || media.fileType === "mov";
}

export function getProvider(media: Media) {
  return media.provider + (isIoF(media) ? " (IoF)" : "");
}
